<template>
  <div class="help-section">
    <b-nav-form class="search">
      <b-form-input
        size="md"
        class="header-search-bar"
        placeholder="Enter here questions and search.."
      ></b-form-input>
      <b-button size="sm" class="my-2 my-sm-0" type="submit">
        <font-awesome-icon icon="search" size="xs" />
      </b-button>
    </b-nav-form>
    <!--        g-->
    <div role="tablist" class="help-list">
      <b-card no-body class="mb-1" v-for="help in helps" :key="help.id">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block href="#" v-b-toggle="'accordion-' + help.id">
            <div class="help-collapse">
              <span>
                <!--              make an icon component-->
                <svg
                  data-name="Layer 1"
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>question</title>
                  <circle fill="#f53156" opacity="0.3" cx="13" cy="13" r="13" />
                  <path
                    fill="#f53156"
                    d="m13 7.4c-1.5-0.1-3 0.7-3.8 2-0.1 0.2-0.1 0.5 0.1 0.7l0.9 0.7c0.2 0.2 0.5 0.1 0.7-0.1 0.6-0.7 1-1.1 1.8-1.1 0.7 0 1.5 0.4 1.5 1.1 0 0.5-0.4 0.8-1.1 1.1-0.8 0.4-1.8 1-1.8 2.3v0.2c0 0.3 0.2 0.5 0.5 0.5h1.6c0.3 0 0.5-0.2 0.5-0.5v-0.1c0-0.9 2.7-1 2.7-3.5 0.3-1.9-1.7-3.3-3.6-3.3zm-0.2 8.2c-0.8 0-1.5 0.7-1.5 1.5s0.7 1.5 1.5 1.5 1.5-0.7 1.5-1.5-0.7-1.5-1.5-1.5z"
                  ></path>
                </svg>

                <!--              make an icon component-->
              </span>
              <span class="ml-4">{{ help.question }}</span>
              <span class="ml-auto" v-if="help.show"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                >
                  <path
                    id="plus_icon"
                    data-name="plus icon"
                    fill="#1c2d41"
                    d="M0,5H12V7H0V5ZM5,0H7V12H5V0Z"
                  ></path>
                </svg>
              </span>
              <!--when collapsed-->
              <span class="ml-auto" v-if="!help.show"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                >
                  <rect
                    id="plus_icon"
                    data-name="plus icon"
                    fill="#f53156"
                    y="5"
                    width="12"
                    height="2"
                  />
                </svg>
              </span>
              <!--              when collapsed-->
            </div>
          </b-button>
        </b-card-header>
        <b-collapse
          :id="'accordion-' + help.id"
          visible
          accordion="my-accordion"
          role="tabpanel"
          @show="help.show = !help.show"
          @hide="help.show = !help.show"
        >
          <b-card-body>
            <b-card-text
              >I start opened because <code>visible</code> is
              <code>true</code></b-card-text
            >
            <b-card-text>{{ help.answer }}</b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <div class="contact-details text-center">
      <h4>Can't find Answer?</h4>
      <p>
        mail us: <a mail-to="aa@aa.com">info@edfore.com</a> Or call us: 999 999
        000
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      helps: [
        {
          id: 1,
          show: false,
          question: "How to subscribe a course ?",
          answer: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
        },
        {
          id: 2,
          question: "How to subscribe live videos ?",
          show: false,
          answer: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
        },
        {
          id: 3,
          question: "How to follow a teacher ?",
          show: false,
          answer: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
        },
        {
          id: 4,
          question: "Is there any courses for plus two students ?",
          show: false,
          answer: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
        },
        {
          id: 5,
          question: "Is psc coaching available ?",
          show: false,
          answer: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
        }
      ]
    };
  }
};
</script>
